type QuestionTreeNode = {
  id?: number | null;
  children_questions?: unknown;
};

const compareQuestionIds = <T extends QuestionTreeNode>(questionA: T, questionB: T) => {
  if (questionA.id == null && questionB.id == null) {
    return 0;
  }

  if (questionA.id == null) {
    return 1;
  }

  if (questionB.id == null) {
    return -1;
  }

  return questionA.id - questionB.id;
};

export const sortQuestionsById = <T extends QuestionTreeNode>(questions: T[] = []): T[] =>
  [...questions]
    .sort(compareQuestionIds)
    .map(question => {
      if (!Array.isArray(question.children_questions) || question.children_questions.length === 0) {
        return question;
      }

      return {
        ...question,
        children_questions: sortQuestionsById(question.children_questions as T[]),
      } as T;
    });

export default sortQuestionsById;
